import { useRecoilValue } from 'recoil';

import { StructuredOperationDetailsModal } from '../../../../../../../../NewApplication/components/StructuredOperationDetailsModal';
import { useGlobalAssetContext } from '../../../../../contexts';
import { useCoesAssetContext } from '../../../../../contexts/products/Coes';

export const ItemDetails = () => {
  const { selectedTab } = useGlobalAssetContext();
  const { modalOpen, offerSelected, setModalOpen } = useCoesAssetContext();

  const marketStatus = useRecoilValue(selectedTab.marketStatusSelector);

  return (
    <StructuredOperationDetailsModal
      isOpen={modalOpen}
      offer={offerSelected}
      onClose={() => setModalOpen(false)}
      marketStatus={marketStatus.originalData}
    />
  );
};
